import { useState } from "react";
import { useManualOccurrence } from "contexts/register/ManualOccurrence";
import { IClient } from "interfaces/Client";
import { ISuperficialClient } from "interfaces/SubClient";
import OccurrenceManagementService from "services/OccurrenceManagementService";
import { AutoComplete } from "../../../../Autocomplete";
import Button from "../../../../Button";
import Input from "../../../../Input";
import * as S from "./styles";
import { useDataList } from "hooks/useDataList";

export default function OccurrenceDataTab() {
  const { occurrenceToEdit, occurrenceType, refetch, addError, removeError } = useManualOccurrence();
  const [numberBO, setNumberBO] = useState<string>(
    occurrenceToEdit.numberBO ?? ""
  );
  const [selectedClient, setSelectedClient] = useState<IClient>(
    occurrenceToEdit.client
  );
  const [selectedSubClient, setSelectedSubClient] =
    useState<ISuperficialClient>({} as ISuperficialClient);

  const clientsData = useDataList<IClient>({
    queryKey: 'listAllClients',
    route: 'clients',
    filter: {
      notPage: true,
    }
  }).data;

  const subClientsData = useDataList<ISuperficialClient>({
    queryKey: 'listAllSuperficialClients',
    route: 'superficial/clients',
    filter: {
      notPage: true,
      relations: {
        superficialAddress: true,
      },
      params: { client: { id: selectedClient?.id } }
    }
  }).data;

  async function handleUpdate() {
    if (occurrenceType === "patrimonial") {
      if (selectedSubClient)
        await OccurrenceManagementService.updateSuperficialClient(
          occurrenceToEdit.id,
          selectedSubClient.id
        );
    }

    if (numberBO)
      await OccurrenceManagementService.updateBONumber(
        occurrenceToEdit.id,
        Number(numberBO)
      );

    refetch();
  }

  return (
    <S.Wrapper>
      <S.ContentWrapper>
        <AutoComplete
          id='client'
          label="Selecione um cliente"
          placeholder="Selecione um cliente"
          defaultValue={occurrenceToEdit?.client}
          options={clientsData?.items ?? []}
          getOptionLabel={(client) => client.name}
          onChange={(client) => setSelectedClient(client as IClient)}
          onBlur={() => {
            if (!selectedClient?.id) {
              addError("noClientSelected", "Necessario selecionar um cliente!")
            } else {
              removeError("noClientSelected")
            }
          }}
        />

        {occurrenceType === "patrimonial" && (
          <AutoComplete
            id='subclient'
            label="Selecione um sub-cliente"
            placeholder="Selecione um sub-cliente"
            defaultValue={
              occurrenceToEdit?.occurrencesSuperficialAddresses
                ?.superficialAddress?.superficialClient
            }
            options={subClientsData?.items ?? []}
            getOptionLabel={(subclient) => subclient.name}
            onChange={(subclient) => setSelectedSubClient(subclient as ISuperficialClient)}
            onBlur={() => {
              if (!selectedSubClient?.id) {
                addError("noSubclientSelected", "Necessario selecionar um subcliente!")
              } else {
                removeError("noSubclientSelected")
              }
            }}
          />
        )}

        <Input
          label="Numero BO - (Opcional)"
          id="numberBO"
          name="numberBO"
          defaultValue={occurrenceToEdit?.numberBO}
          required
          type="text"
          onChange={(event) => setNumberBO(event.target.value)}
        />
      </S.ContentWrapper>

      <S.ButtonWrapper>
        <Button title="Atualizar informações" onClick={handleUpdate} />
      </S.ButtonWrapper>
    </S.Wrapper>
  );
}
